import QuotationForm from "./QuotationForm";
import BackButton from "../../../../components/Button/BackButton";

const CreateQuotationPage = () => (
  <div>
    <div className="flex items-center gap-3 mb-5">
      <BackButton />
      <h1 className="text-[22px] font-semibold tracking-tight text-gray-900">New Quotation</h1>
    </div>

    <QuotationForm />
  </div>
);

export default CreateQuotationPage;
